<div class="sample-container">
    <div class="h1">
        Demande de confirmation
    </div>
    <div class="footer">
        <aa-btn-action-transparent
            [btnText]="'Yes (je perds tout)'"
            (click)="close(true)"
            [btnWidth]="'100%'"
        >
        </aa-btn-action-transparent>&nbsp;
        <aa-btn-action-secondary
            [btnText]="'No (Je continue)'"
            (click)="close(false)"
            [btnWidth]="'100%'"
        >
        </aa-btn-action-secondary>
    </div>
</div>
